/**
 * Auth provider resolution + login initiation.
 *
 * The backend env var AUTH_PROVIDER ('emergent' | 'google') is the single source
 * of truth. The frontend reads it at runtime from GET /api/auth/config, so flipping
 * the env var on chekdeal-api switches the login flow with no frontend rebuild.
 * If the config fetch fails, we fall back to 'emergent' (the safe legacy path).
 */
import { API_URL } from '../api';
import { setAuthRedirect } from './mobileStorage';

let cachedProvider = null;

export async function getAuthProvider() {
  if (cachedProvider) return cachedProvider;
  try {
    const res = await fetch(`${API_URL}/api/auth/config`);
    const data = await res.json();
    cachedProvider = (data && data.auth_provider) || 'emergent';
  } catch (e) {
    cachedProvider = 'emergent';
  }
  return cachedProvider;
}

/**
 * Start the login flow. Centralizes the provider choice so all entry points
 * (Header, AuthPrompt, LandingPage, SharedAnalysis) stay identical.
 */
export async function startLogin(next = '/analyze') {
  // Preserve post-login destination for both providers (mobile-safe storage).
  setAuthRedirect(next || '/analyze');
  const provider = await getAuthProvider();

  if (provider === 'google') {
    // Direct Google OAuth — hand off to our backend, which 302s to Google.
    window.location.href = `${API_URL}/api/auth/google/login?next=${encodeURIComponent(next || '/analyze')}`;
  } else {
    // Legacy Emergent-managed OAuth.
    const redirectUrl = window.location.origin + '/auth/callback';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  }
}
